module.exports = __webpack_public_path__ + "img/patient.23afbf1f.svg";